// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: 'e6817ed7-1a6d-41e9-b954-4cd104f67b51',
    authority:
      'https://login.microsoftonline.com/7b6b8b89-28ee-4d2e-8bea-d52f79c6af8f',
    redirectUri: '/',
    postLogoutRedirectUri: '/'
  },
  system: {
    allowNativeBroker: false // Disables WAM Broker
  }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['email', 'profile']
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};

// Add the scout-chatcenter-server URL for chat service here.
// Local test URL: http://localhost:8080
// PROD URL: https://scout-chatcenter-server.azurewebsites.net OR https://scout-chatcenter.travelctm.com
export const scoutChatCenterServerUrl =
  'https://scout-chatcenter.travelctm.com';

// Customize the initial chat question (message) based on the user’s region.
export function getInitialQuestion(region) {
  const DEFAULT_CHAT_INITIAL_QUESTION =
    'Can you please provide your CTM booking number?';

  const initialQuestionWordingMap = {
    AU: 'Can you please provide your CTM booking number?',
    GB: 'Can you please provide your CTM booking number?',
    HKG: 'Can you please provide your CTM booking number?',
    NZ: 'Can you please provide your CTM booking number?',
    SG: 'Can you please provide your CTM booking number?',
    US: 'Thank you for your patience while I check on your request.'
  };

  const regionKey = region?.toUpperCase();
  const wording =
    initialQuestionWordingMap[regionKey] || DEFAULT_CHAT_INITIAL_QUESTION;
  return wording;
}
